<template>
  <div class="page text-center">
    <div class="banner py-5 bg-light">
      <div class="container">
        <h1 class="display-4 font-weight-bold text-primary">
          WELCOME TO KDIY ORDER APP
        </h1>
        <p class="lead text-muted">Seamlessly place your orders with ease and efficiency.</p>
        <button class="get-started-btn mt-4" @click="goToPayment">
          Get Started
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PosLoginView",
  methods: {
    async goToPayment() {
      const currentUser = JSON.parse(localStorage.getItem('current_user') || '{}');

      const companyName = currentUser?.companyName;

      if (!companyName) {
        console.error('Company name is missing in user object. Cannot redirect.');
        return;
      }

      const targetUrl = `https://kdiy.pos.co.zm/payment/${companyName}`;

      window.location.href = targetUrl;
    }
  }
};
</script>

<style scoped>
.page {
  background: rgb(64, 67, 74);
  background: linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
}

.banner {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  background: #40434A;
  margin-top: -2px !important;
  max-height: 100%;
}

.get-started-btn {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.get-started-btn:hover {
  background-color: #0056b3;
}
</style>
